import Vue from 'vue'
import Vuetify, { VTextField, VList, VTooltip, VIcon, VBtn, VImg, VRadioGroup, VCheckbox } from 'vuetify/lib'
import {ClickOutside} from 'vuetify/lib/directives'

import theme from './theme'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons/iconfont/material-icons.css'
import '@/sass/custom-styles.scss'

Vue.use(Vuetify, {
  directives: {
    ClickOutside
  },
  components: {
    VTextField,
    VList,
    VTooltip,
    VIcon,
    VBtn,
    VImg,
    VRadioGroup,
    VCheckbox
  },
})
let opts =  {
  icons: {
    iconfont: 'mdi',
  },
  breakpoint: {
    thresholds: {
      lg: 3000,
    },
  },
  theme
}


export default new Vuetify(opts)
